import type { IconData } from '@stacksjs/iconify-core'

export const stool: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M14 34h20M44.979 9.883c-.148-3.937-3.501-6.59-7.439-6.71C34.438 3.078 30.045 3 24 3s-10.438.078-13.54.173c-3.938.12-7.291 2.773-7.439 6.71a30 30 0 0 0 0 2.234c.148 3.937 3.501 6.59 7.439 6.71c3.1.095 7.495.173 13.54.173s10.439-.078 13.54-.173c3.938-.12 7.291-2.773 7.439-6.71a30 30 0 0 0 0-2.234M4.502 42.673L11 19h8L9.913 43.393c-.265.711-.793 1.309-1.536 1.465A6.7 6.7 0 0 1 7 45c-.393 0-.787-.034-1.153-.085c-1.053-.146-1.626-1.218-1.345-2.242m38.996 0L37 19h-8l9.087 24.393c.266.711.793 1.309 1.536 1.465c.383.08.849.142 1.377.142c.394 0 .787-.034 1.153-.085c1.053-.146 1.627-1.218 1.345-2.242\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default stool
